import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Wrapper from '../../../components/Wrapper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { getLenderInfo } from './../../../actions';
import PageTitle from '../../../components/PageTitle';
import RateTableContainer from '../Rate/RateTable';
import AdjustmentTableContainer from '../Adjustment/AdjustmentTable';
import FileTableContainer from '../File/FileTable';

const style = {
  tabs: {
    borderBottom: '1px solid #CCC',
  },
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box py={2}>{children}</Box>}
    </Typography>
  );
}

function a11yProps(index) {
  return {
    id: `lender-details-tab-${index}`,
    'aria-controls': `lender-details-tabpanel-${index}`,
  };
}

class LenderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
    };
    this.onChangeTab = this.onChangeTab.bind(this);
  }

  componentDidMount() {
    this.props.getLenderInfo(this.props.match.params.id);
  }

  onChangeTab(event, newValue) {
    this.setState({tabIndex: newValue});
  }

  getLenderDetailsTab() {
    const { classes } = this.props;
    const result = (
      <Paper square={true} elevation={0}>
        <Tabs
          value={this.state.tabIndex}
          onChange={this.onChangeTab}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          className={ classes.tabs }
        >
          <Tab label="Rate Table" {...a11yProps(0)} />
          <Tab label="Adjustment Table" {...a11yProps(1)} />
          <Tab label="Rate Files" {...a11yProps(2)} />
        </Tabs>
        <TabPanel value={this.state.tabIndex} index={0}>
          <RateTableContainer />
        </TabPanel>
        <TabPanel value={this.state.tabIndex} index={1}>
          <AdjustmentTableContainer />
        </TabPanel>
        <TabPanel value={this.state.tabIndex} index={2}>
          <FileTableContainer />
        </TabPanel>
      </Paper>
    );
    return result;
  }

  render() {
    return (
      <div>
        <PageTitle title={(this.props.lender && this.props.lender.name) ? this.props.lender.name : ''} />
        <Wrapper>
          {this.getLenderDetailsTab()}
        </Wrapper>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    lender: state.lender.lender,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLenderInfo: (lenderId) => dispatch(getLenderInfo(lenderId))
  };
};

LenderDetails.propTypes = {
  match: PropTypes.any,
  classes: PropTypes.object,
  lender: PropTypes.object,
  getLenderInfo: PropTypes.func 
};

export default compose(
  withStyles(style),
  connect(mapStateToProps, mapDispatchToProps)
)(withRouter(LenderDetails));
